import axios from '@/bootstrap'
const endpoint = 'users'

export default class UsersService {
  activate(id) {
    return axios.post(`/api/${endpoint}/activate/${id}`).then(res => res.data)
  }

  deactivate(id) {
    return axios.post(`/api/${endpoint}/deactivate/${id}`).then(res => res.data)
  }

  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }

  report(params) {
    return axios.get(`/api/${endpoint}/report`, params).then(res => res.data)
  }

  retrieve(id) {
    return axios.get(`/api/${endpoint}/${id}`).then(res => res.data)
  }

  create(data) {
    return axios.post(`/api/${endpoint}`, data).then(res => res.data)
  }

  update(id, data) {
    return axios.put(`/api/${endpoint}/${id}`, data).then(res => res.data)
  }

  delete(id) {
    return axios.delete(`/api/${endpoint}/${id}`).then(res => res.data)
  }

  user() {
    return axios.get(`/api/${endpoint}/user`).then(res => res.data)
  }

  roles() {
    return axios.get(`/api/${endpoint}/roles`).then(res => res.data)
  }

  permissions() {
    return axios.get(`/api/${endpoint}/permissions`).then(res => res.data)
  }
}
